import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import {
  loadRecommendationsForPlacesEvents,
  loadRecommendationsForPlacesStreams,
  loadRecommendationsForPlacesVirtualMuseums
} from '@common/redux/slices/recommendation.slice';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { loadPlace } from "@common/redux/slices/places.slice";
import { SingleMuseum } from "@kursk/components/pages/SingleMuseum/SingleMuseum";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SingleMuseum/>
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadPlace({ _id: id })),
    store.dispatch<any>(loadRecommendationsForPlacesEvents({ _id: id })),
    store.dispatch<any>(loadRecommendationsForPlacesStreams({ _id: id })),
    store.dispatch<any>(loadRecommendationsForPlacesVirtualMuseums({ _id: id })),
  ]);
  const place = store.getState().placesList?.place;
  if (!place?._id) {
    return {
      props: { notFound: true }
    };
  }
});
